module.exports = __webpack_public_path__ + "static/media/innovatex.82fcb19d.png";